module.exports = __webpack_public_path__ + "img/soldier_qr_title.aa1b4932.png";